module.exports = __webpack_public_path__ + "img/citiserve.fd2f43fc.png";